<template>
  <article>
    <section class="xbed-sub-title">
      <span>{{title}}</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>广告设计</BreadcrumbItem>
        <BreadcrumbItem>{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab">
      <TabPane
        v-for="(bundle, i) in bundles"
        :key="i"
        :label="bundle.tabName"
        :name="bundle.name"
        :ref="bundle.name"
      >
        <Form @submit.native.prevent="preventSubmit" inline>
          <FormItem
            prop="keyword"
            label="城市"
            :label-width="80"
            v-show="bundle.name == 'cityRecom'"
          >
            <Select filterable style="width:150px" v-model="bundle.checkCity">
              <Option value="0">全部</Option>
              <Option v-for="(city,index) in cityArr" :key="index" :value="city">{{city}}</Option>
            </Select>
          </FormItem>
          <FormItem v-show="bundle.name == 'cityRecom'">
            <Button type="primary" @click="queryCity">查询</Button>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="openAddModal">新增</Button>
          </FormItem>
        </Form>
        <Form @submit.native.prevent="preventSubmit" inline>
          <FormItem prop="keyword" label="适用终端" :label-width="80">
            <Select
              style="width:150px"
              v-model="bundle.searchTerminal"
              @on-change="queryTerminal"
            >
              <Option value="500">不限</Option>
              <Option
                v-for="(index) in [0,1,2,3]"
                :key="index"
                :value="index"
              >{{['PC','Ios端','Android端','易订小程序'][index]}}</Option>
            </Select>
          </FormItem>
        </Form>
        <Table stripe :loading="bundle.loading" :columns="bundle.name === 'themeRecommed' ? columns2 : columns" :data="bundle.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page
            show-sizer
            show-total
            placement="top"
            :total="bundle.count"
            :current="bundle.page"
            @on-page-size-change="changePageSize"
            @on-change="changePage"
          ></Page>
        </div>
      </TabPane>
    </Tabs>

    <Modal
      v-model="addModal.display"
      ref="addModal"
      :title="addModal.title"
      :loading="true"
      @on-ok="preAddRecommendRoom"
      @on-cancel="cancelAddRecommendRoom"
      width="800"
    >
      <Form @submit.native.prevent="preventSubmit" inline v-show="isEdit == false">
        <FormItem prop="keyword" label="城市" :label-width="60">
          <Select filterable style="width:150px" v-model="addModal.addCity">
            <Option value="0">全部</Option>
            <Option v-for="(city,index) in cityArr" :key="index" :value="city">{{city}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="keyword" label="门店名称" :label-width="80">
          <Input
            v-model="addModal.searchChainName"
            @on-blur="trimlrSpace(addModal,'searchChainName')"
            placeholder="门店名称"
          ></Input>
        </FormItem>
        <FormItem prop="keyword" label="房间名称" :label-width="80">
          <Input
            v-model="addModal.searchRoomName"
            @on-blur="trimlrSpace(addModal,'searchRoomName')"
            placeholder="房间名称"
          ></Input>
        </FormItem>
        <FormItem prop="keyword" label="房间号" :label-width="80">
          <Input
            v-model="addModal.searchRoomNo"
            @on-blur="trimlrSpace(addModal,'searchRoomNo')"
            placeholder="房间号"
          ></Input>
        </FormItem>

        <FormItem>
          <Button type="primary" @click="queryNotExitst">查询</Button>
        </FormItem>
      </Form>
      <Table
        highlight-row
        :columns="addModal.columns"
        :loading="addModal.loading"
        :data="addModal.notExistRecommendRoomList"
        @on-selection-change="selectRecommendRoom"
      ></Table>
      <div style="margin-top:20px">
        <Page
          :total="addModal.count"
          :current="addModal.page"
          @on-page-size-change="addModalChangePageSize"
          @on-change="addModalChangePage"
        ></Page>
      </div>
      <Form
        @submit.native.prevent="preventSubmit"
        :rules="addModalFormRules"
        ref="addModalForm"
        :model="addModal"
        style="margin-top:20px"
      >
        <FormItem label="终端" prop="terminal">
          <CheckboxGroup v-model="addModal.terminal" @on-change="reSelectAll">
            <Checkbox :label="0">
              <span>PC</span>
            </Checkbox>
            <Checkbox :label="1">
              <span>Xbed Ios端</span>
            </Checkbox>
            <Checkbox :label="2">
              <span>Xbed Android端</span>
            </Checkbox>
            <Checkbox :label="3">
              <span>Xbed易订小程序</span>
            </Checkbox>
            <Button
              :type="isAll?'error':'primary'"
              size="small"
              style="margin-left:30px"
              @click="sellectAll"
            >{{isAll?'取消全选':'全选'}}</Button>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="权重" prop="weight">
          <Select style="width:120px" v-model="addModal.weight">
            <Option :value="1">1</Option>
            <Option :value="2">2</Option>
            <Option :value="3">3</Option>
            <Option :value="4">4</Option>
            <Option :value="5">5</Option>
            <Option :value="6">6</Option>
            <Option :value="7">7</Option>
            <Option :value="8">8</Option>
            <Option :value="9">9</Option>
            <Option :value="10">10</Option>
          </Select>
        </FormItem>
        <FormItem label="主题推荐" v-if="currBundleObj.name === 'themeRecommed'">
          <RadioGroup v-model="addModal.type">
            <Radio v-for="(item, index) in themeRadio" :key="index" :label="item.id" style="margin-right: 15px;">{{ item.value }}</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
/* eslint-disable */
// import mockData from './recommend-room-mock-data.json'
import Utils from "../../utils";
import API from "../../api";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev"); 

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token")
    }
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
      this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
    }
  },

  async mounted() {
    this.$Notice.config({
      top: 100
    });

    // 加载 推荐房源
    this.xGetRecHouse();

    // 加载城市
    const cityRes = (await API.omsAPI[
      this.env
    ].cleaner.querySelectListForCleanOrder({}, this.token)).data;
    if (cityRes.retCode) {
      this.$Notice.error({
        title: "查询城市失败",
        desc: cityRes.msg
      });
      return;
    }
    this.cityArr = cityRes.city;
  },
  data() {
    return {
      checkCity: "0",
      cityArr: [],
      isEdit: false,
      isAll: false,
      title: "精选、推荐房源",
      currBundleName: "globalRecoml",
      currBundleIndex: 0,
      currBundleObj: {
        name: "globalRecoml",
        tabName: "全局推荐",
        type: 6,
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        checkCity: "0",
        searchTerminal: "500"
      },
      themeRadio: [
        {
          value: '商务出行',
          id: 11
        },
        {
          value: '家庭出游',
          id: 12
        },
        {
          value: '情侣约会',
          id: 13
        },
        {
          value: '聚会轰趴',
          id: 14
        },
        {
          value: '长租公寓',
          id: 15
        },
      ],
      bundles: [
        {
          name: "globalRecoml",
          tabName: "全局推荐",
          type: 6,
          count: 0, //记录总数
          pageCount: 0, //页面总数
          page: 1, // 第几页
          pageSize: 10, // 每页数量
          loading: false,
          data: [],
          checkCity: "0",
          searchTerminal: "500"
        },
        {
          name: "cityRecom",
          tabName: "城市推荐",
          type: 7,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: [],
          checkCity: "0",
          searchTerminal: "500"
        },
        {
          name: "themeRecommed",
          tabName: "主题推荐",
          moreType: '11,12,13,14,15',   // 主题推荐 时传 moreType，不用传 type
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: [],
          checkCity: "0",
          searchTerminal: "500"
        },
        {
          name: "brandRecommed",
          tabName: "品牌推荐",
          type: 1,
          count: 0,
          pageCount: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          data: [],
          checkCity: "0",
          searchTerminal: "500"
        }
      ],
      columns: [
        {
          title: "ID",
          key: "id",
          align: "center",
          width: 120
        },
        {
          title: "房间ID",
          key: "roomId",
          align: "center",
          width: 110
        },
        {
          title: "门店名称",
          key: "chainName",
          align: "center",
          width: 210
        },
        {
          title: "展示房间名称",
          key: "roomName",
          align: "center",
          width: 250
        },
        {
          title: "房间号",
          key: "roomNo",
          align: "center",
          width: 230
        },
        {
          title: "权重",
          key: "displayWeight",
          align: "center",
          width: 80
        },
        {
          title: "终端",
          key: "terminal",
          align: "center",
          width: 342,
          render: (h, params) => {
            return h(
              "span",
              params.row.terminals
                .replace(/,$/, "")
                .split(",")
                .sort()
                .map(
                  item =>
                    ["PC", "Xbed Ios端", "Xbed Android端", "Xbed易订小程序"][
                      item
                    ]
                )
                .join(",")
            );
          }
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", {}, [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    margin: "3px"
                  },
                  on: {
                    click: () => {
                      this.isEdit = true;
                      params.row._disabled = true;
                      this.addModal.notExistRecommendRoomList = [];
                      this.addModal.notExistRecommendRoomList.push(params.row);
                      this.addModal.terminal = params.row.terminals
                        ? params.row.terminals
                            .replace(/,$/, "")
                            .split(",")
                            .sort()
                            .map(item => Number(item))
                        : [];
                      this.isAll = this.addModal.terminal.length == 4 ? true : false;
                      this.addModal.weight = params.row.displayWeight
                        ? params.row.displayWeight
                        : 1;
                      this.addModal.display = true;
                      this.addModal.title = '编辑' + this.currBundleObj.tabName
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    margin: "3px"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `您确定要删除吗?`;
                          return modalH(
                            "div",
                            {
                              style: {
                                fontSize: "16px"
                              }
                            },
                            modalText
                          );
                        },
                        onOk: () => {
                          this.delRecommendRoom(params.index);
                        }
                      });
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      // 主题推荐列表（多 ‘主题类型’ 列）
      columns2: [
        {
          title: "ID",
          key: "id",
          align: "center",
          width: 100
        },
        {
          title: "房间ID",
          key: "roomId",
          align: "center",
          width: 100
        },
        {
          title: "门店名称",
          key: "chainName",
          align: "center",
          width: 200
        },
        {
          title: "展示房间名称",
          key: "roomName",
          align: "center",
          width: 200
        },
        {
          title: "房间号",
          key: "roomNo",
          align: "center",
          width: 200
        },
        {
          title: "权重",
          key: "displayWeight",
          align: "center",
          width: 80
        },
        {
          title: "主题类型",
          key: "type",
          align: "center",
          width: 150,
          render: (h, params) => {
            let themeName = ''
            this.themeRadio.map(item => {
              if (item.id == params.row.type) {
                themeName = item.value
              }
            })
            return h (
              "span",
              {},
              themeName
            )
          }
        },
        {
          title: "终端",
          key: "terminal",
          align: "center",
          width: 313,
          render: (h, params) => {
            return h(
              "span",
              params.row.terminals
                .replace(/,$/, "")
                .split(",")
                .sort()
                .map(
                  item =>
                    ["PC", "Xbed Ios端", "Xbed Android端", "Xbed易订小程序"][
                      item
                    ]
                )
                .join(",")
            );
          }
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", {}, [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    margin: "3px"
                  },
                  on: {
                    click: () => {
                      this.isEdit = true;
                      params.row._disabled = true;
                      this.addModal.notExistRecommendRoomList = [];
                      this.addModal.notExistRecommendRoomList.push(params.row);
                      this.addModal.terminal = params.row.terminals
                        ? params.row.terminals
                            .replace(/,$/, "")
                            .split(",")
                            .sort()
                            .map(item => Number(item))
                        : [];
                      this.isAll = this.addModal.terminal.length == 4 ? true : false;
                      this.addModal.weight = params.row.displayWeight
                        ? params.row.displayWeight
                        : 1;
                      this.addModal.type = params.row.type
                        ? params.row.type * 1
                        : 11;
                      this.addModal.display = true;
                      this.addModal.title = '编辑' + this.currBundleObj.tabName
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    margin: "3px"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `您确定要删除吗?`;
                          return modalH(
                            "div",
                            {
                              style: {
                                fontSize: "16px"
                              }
                            },
                            modalText
                          );
                        },
                        onOk: () => {
                          this.delRecommendRoom(params.index);
                        }
                      });
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      addModal: {
        display: false,
        title: '',
        slectArr: [], // 选择推荐的房源
        terminal: [], //终端
        weight: 1, //权重
        type: 11,
        page: 1,
        pageSize: 10, //hardcode
        count: 0,
        pageCount: 0,
        addCity: "0", //城市筛选
        searchChainName: "",
        searchRoomName: "",
        searchRoomNo: "",
        columns: [
          {
            title: "门店名称",
            key: "chainName",
            align: "center",
            width: 200
          },
          {
            title: "房间号",
            key: "roomNo",
            align: "center",
            width: 200
          },
          {
            title: "房间名称",
            key: "roomName",
            align: "center"
          },
          {
            type: "selection",
            width: 60,
            align: "center"
          }
        ],
        // 未推荐的房间列表 / 编辑的房间
        notExistRecommendRoomList: []
      },
      addModalFormRules: {
        terminal: [
          {
            required: true,
            type: "array",
            message: "请选择终端",
            trigger: "change"
          }
        ],
        weight: [
          {
            required: true,
            type: "number",
            message: "权重值不能为空",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    // 切换tab
    toggleTab(tabName) {
      this.currBundleName = tabName;
      this.bundles.map((item, index) => {
        if (item.name === tabName) {
          this.currBundleObj = item
          this.currBundleIndex = index
        }
      })
    },

    // 获取推荐房源
    async xGetRecHouse(curr = [0, 1, 2, 3]) {
      for (let i = 0; i < curr.length; i++) {
        this.bundles[curr[i]].loading = true;
        let bundle = this.bundles[curr[i]];
        const resp = (await this.queryRecommendRoomList(
          bundle
        )).data;
        this.bundles[curr[i]].data = resp.list;
        this.bundles[curr[i]].page = resp.pageNum || 1;
        this.bundles[curr[i]].pageSize = resp.pageSize;
        this.bundles[curr[i]].pageCount = resp.pageCount;
        this.bundles[curr[i]].count = resp.total;

        this.bundles[curr[i]].loading = false;
      }
    },
    queryTerminal() {
      this.bundles[this.currBundleIndex].page = 1;
      return this.query([this.currBundleIndex]);
    },
    queryCity() {
      return this.xGetRecHouse([1]);
    },
    // 推荐房源弹窗（新增/编辑弹窗）
    openAddModal() {
      this.isEdit = false;
      this.isAll = false;
      this.addModal.title = '新增' + this.currBundleObj.tabName
      this.addModal.notExistRecommendRoomList = [];
      this.addModal.display = true;
      this.addModal.loading = true;
      this.addModal.slectArr = [];
      this.addModal.terminal = [];
      this.addModal.weight = 1;
      this.addModal.addCity = "0";
      this.$nextTick(() => {
        this.queryNotExistRecommendRooms();
      });
    },
    // 列表分页
    changePage(pageIndex) {
      this.bundles[this.currBundleIndex].page = pageIndex;
      return this.query([this.currBundleIndex]);
    },
    changePageSize(pageSize) {
      this.bundles[this.currBundleIndex].page = 1;
      this.bundles[this.currBundleIndex].pageSize = pageSize;
      return this.query([this.currBundleIndex]);
    },
    // 非全选情况
    reSelectAll() {
      this.isAll = this.addModal.terminal.length == 4 ? true : false;
    },
    // 全选/取消全选
    sellectAll() {
      if (this.addModal.terminal.length != 4) {
        this.addModal.terminal = [0, 1, 2, 3];
        this.isAll = true;
      } else {
        this.addModal.terminal = [];
        this.isAll = false;
      }
    },
    // 弹窗的分页事件
    addModalChangePage(pageIndex) {
      this.addModal.page = pageIndex;
      return this.queryNotExistRecommendRooms();
    },
    addModalChangePageSize(pageSize) {
      this.addModal.page = 1;
      this.addModal.pageSize = pageSize;
      return this.queryNotExistRecommendRooms();
    },

    query(curr) {
      return this.xGetRecHouse([curr]);
    },

    // 查询未推荐的房间列表
    queryNotExitst() {
      this.addModal.page = 1;
      return this.queryNotExistRecommendRooms();
    },

    // 去除两侧空格
    trimlrSpace(obj, name) {
      obj[name] = obj[name].replace(/(^\s*)|(\s*$)/g, "");
    },

    // 加载未推荐的房间列表
    async queryNotExistRecommendRooms() {
      this.addModal.loading = true;
      let params = {
        url: '/api/recommendRoom/selectNotExistRoomList',
        page: this.addModal.page,
        pageSize: this.addModal.pageSize,
        chainName: this.addModal.searchChainName, // 门店名称(模糊查询)
        roomName: this.addModal.searchRoomName, //	房间名称(模糊查询)
        roomNo: this.addModal.searchRoomNo, // 房间号(模糊查询)
        city: this.addModal.addCity == "0" ? "" : this.addModal.addCity, //城市名称
        type: this.currBundleObj.type
      }
      if (this.currBundleObj.name == 'themeRecommed') {
        params.moreType = this.currBundleObj.moreType
      }
      
      let resp = (await API.omsAPI[this.env].clientServer.getRecommendRoomList(params, this.protHeaders)).data;
      this.addModal.notExistRecommendRoomList = resp.result;
      this.addModal.count = resp.count;
      this.addModal.page = resp.page;
      this.addModal.pageSize = resp.pageSize;
      this.addModal.loading = false;
    },
    // 获取列表数据
    queryRecommendRoomList(bundle) {
      let params = {
        url: "/api/recommendRoom/list",
        pageNum: bundle.page || 1,
        pageSize: bundle.pageSize || 10,
        terminal: bundle.searchTerminal == "500" ? "" : bundle.searchTerminal,
        city: bundle.checkCity == "0" ? "" : bundle.checkCity,
        type: bundle.type
      };
      if (bundle.name == 'themeRecommed') {
        params.moreType = bundle.moreType
      }

      return API.omsAPI[this.env].clientServer.getRecommendRoomList(params, this.protHeaders);
    },
    // 选择未推荐的房间列表项
    selectRecommendRoom(select) {
      this.addModal.slectArr = [];
      select.forEach(ele => this.addModal.slectArr.push(ele));
    },
    // 弹窗确定提交
    async preAddRecommendRoom() {
      let validResult = false;
      this.$refs.addModalForm.validate(valid => {
        validResult = valid;
      });
      if (!validResult) {
        this.$refs.addModal.buttonLoading = false;
        return;
      }

      let resp = {},
        type = this.currBundleObj.name == 'themeRecommed' ? this.addModal.type : this.currBundleObj.type,
        terminal = "",
        weight = 1;
      
      if (this.isEdit) {
        //编辑
        let currentData = this.addModal.notExistRecommendRoomList[0];
        // console.info(
        //   typeof this.addModal.terminal.sort().join(",") +
        //     ":" +
        //     this.addModal.terminal.sort().join(","),
        //   "length：" + this.addModal.terminal.sort().join(",").length
        // );
        let params = {
          updateName: this.username,
          id: currentData.id,
          roomId: currentData.roomId,
          type,
          displayWeight: this.addModal.weight,
          terminals: this.addModal.terminal.sort().join(",")
        }
        resp = (await API.omsAPI[this.env].advert.XeditRecommendRoom(
          params,
          this.token
        )).data;
      } else {
        //新增
        if (!this.addModal.slectArr.length) {
          this.$Notice.error({
            title: "请选择门店"
          });
          this.$refs.addModal.buttonLoading = false;
          return;
        }
        let param = "[";
        terminal = this.addModal.terminal.join(",");
        weight = this.addModal.weight;

        this.addModal.slectArr.forEach(obj => {
          obj.displayWeight = weight;
          obj.terminals = terminal;
          obj.type = type;
          let objString = "{";
          for (let pro in obj) {
            objString += `"${pro}":"${obj[pro]}",`;
          }
          objString = objString.replace(/,$/, "");
          objString += "}";
          param += objString;
        });
        param += "]";
        resp = (await API.omsAPI[this.env].advert.xAddRecommendRooms(
          { json_data: param.toString() },
          this.token
        )).data;
      }
      if (resp.retCode) {
        this.$Notice.error({
          title: this.isEdit == true ? "编辑推荐房间失败" : "新增推荐房间失败",
          desc: resp.msg
        });
        this.$refs.addModal.buttonLoading = false;
        return;
      } else {
        this.$Notice.success({
          title: this.isEdit == true ? "编辑推荐房间成功" : "新增推荐房间成功"
        });
      }
      this.addModal.display = false;

      // 重新刷新推荐房源列表
      if (this.isEdit) {
        // 刷新本地数据
        let currenData = this.bundles[this.currBundleIndex].data[
          this.addModal.notExistRecommendRoomList[0]["_index"]
        ];
        currenData.terminals = this.addModal.terminal.sort().join(",");
        currenData.displayWeight = this.addModal.weight;
        currenData.type = type;
      } else {
        // 重新请求
        this.bundles[this.currBundleIndex].page = 1;
        this.xGetRecHouse([this.currBundleIndex]);
        this.resetAddModalData();
      }

      // 清除modal数据
    },
    // 清除modal数据
    cancelAddRecommendRoom() {
      this.resetAddModalData();
    },
    resetAddModalData() {
      this.addModal.count = 0;
      this.addModal.addCity = "";
      this.isAll = false;
      this.isEdit = false;
      this.addModal.slectArr = [];
      this.addModal.terminal = [];
      this.addModal.notExistRecommendRoomList = [];
      this.addModal.searchChainName = "";
      this.addModal.searchRoomName = "";
      this.addModal.searchRoomNo = "";
      this.addModal.page = 1;
      this.addModal.type = 11;
    },
    // 删除房源
    async delRecommendRoom(index) {
      let type = this.bundles[this.currBundleIndex].data[index].type;
      let id = this.bundles[this.currBundleIndex].data[index].id;
      let resp = (await API.omsAPI[this.env].advert.xDeleteRecommendHouse(
        {
          id,
          updateName: this.username,
          type
        },
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "删除精选、推荐房源失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除精选、推荐房源成功"
        });
        this.bundles[this.currBundleIndex].data.splice(index, 1);
      }
    }
  },

  // 获取所有选中的元素
  selectTab(selection) {
    //当前页面
    this.page;

    //所有选中的元素 二维数组
    this.selectArr[this.page] = selection;

    //需要显示的所有的元素
    this.showAllSelect = [...new Set(this.selectArr)].filter(item => {
      if (item) {
        return item.map(it => {
          return it.roomId;
        });
      }
    });
  }
};
</script>

<style lang="scss">
.hide-theme {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/advert/recommend-room.vue